import React from 'react';
import {getArrayByNumber} from "../../../shared/utils/arrayUtils";
import {typeHoursLabel} from "../../../common/typeHours";
import {padNumber} from "../../../shared/utils/dateUtils";


const PrintCalendarDataTr = ({employee, arrayDate}: { arrayDate: any[], employee: any }) => {
    const maxTr = employee.hours.reduce((acc: number, el: any) => acc < el ? acc : el.list.length, 0)

    return (
        <>
            <tr>
                <td rowSpan={maxTr + 1} className={'td-name'}>{employee.employee.name} {employee.employee.surname}</td>
            </tr>
            {getArrayByNumber(maxTr).map((el, index) => <tr>
                <td>turno {index + 1}</td>
                {arrayDate.map(d => {
                    const findHour = employee.hours.find((ele: any) => ele.day === new Date(d).getDate())
                    const print = findHour ? findHour.list[index] : undefined
                    return <td>
                        {print && <>
                            <div>{typeHoursLabel[print.type]}</div>
                            <div>
                                {padNumber(print?.start.hour)}:{padNumber(print?.start.minute)} - {padNumber(print?.end.hour)}: {padNumber(print?.end.minute)}
                            </div>
                        </>
                        }</td>
                })}
            </tr>)}

        </>

    );
};

export default PrintCalendarDataTr;
